// extracted by mini-css-extract-plugin
export default {"wrapper-prioritize":"style_wrapper-prioritize__3e4+r","label":"style_label__EBix4","select":"style_select__1oXzN","wrapper-arrival-time":"style_wrapper-arrival-time__7ft6d"};